import React, { FC, useCallback, useMemo, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { getInitialValues, getValidationSchema } from '../../../../utils/helpers';
import Dialog from '@material-ui/core/Dialog/Dialog';
import { Form, Formik } from 'formik';
import classes from '../../WebinarsManagementPage/WebinarsManagementPage.module.scss';
import AppBar from '@material-ui/core/AppBar/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import FieldWithConfig from '../../../../components/FormWithConfig/FieldWithConfig';
import { postCoursesLessons } from '../../../../api';
import yup from '../../../../utils/validation';

export type Props = {
  saveContent?: any;
  openModal: any;
  coursesId?: any;
  reload: any;
  openIs: boolean;
  filterSavePayload?: (payload) => any;
};
const CreateCoursesLesson: FC<Props> = ({
  openModal,
  openIs,
  filterSavePayload,
  saveContent,
  reload,
  coursesId,
  ...rest
}) => {
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState('lg');
  const [submit, setSubmit] = React.useState();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const input = [
    {
      name: 'name',
      label: 'Назва курса',
      fieldType: 'text',
      required: true,
      validate: yup.string().required(),
    },
    {
      name: 'author',
      label: 'Автор уроку',
      fieldType: 'text',
      required: false,
      validate: null,
    },
    {
      name: 'has_test',
      label: 'Додати тест після уроку',
      fieldType: 'checkboxTextOne',
      required: false,
      validate: null,
      value: false,
    },
    {
      name: 'test_questions_count',
      label: 'Кількість тестових питань',
      fieldType: 'number',
      required: true,
      validate: yup.string().required(),
      min: 1,
    },
    {
      name: 'order_number',
      label: 'Порядковий номер уроку',
      fieldType: 'number',
      required: true,
      validate: yup.string().required(),
      min: 1,
    },
    {
      name: 'test_time',
      label: 'Час проходження уроку',
      fieldType: 'number',
      required: true,
      validate: yup.string().required(),
      min: 0,
    },
    {
      name: 'text',
      label: 'Основний текст для сторінки курсу',
      fieldType: 'richText',
      required: false,
      validate: null,
    },
  ];
  const content = {
    has_test: true,
  };
  const initialValues = useMemo(() => getInitialValues(input, content), [input]);
  const validationSchema = useMemo(() => getValidationSchema(input), [input]);
  const handleClose = useCallback(() => {
    openModal(false);
  }, [openModal]);

  const handleMaxWidthChange = event => {
    setMaxWidth(event.target.value);
  };

  const handleFullWidthChange = event => {
    setFullWidth(event.target.checked);
  };

  const submitWebinars = async (values, actions) => {
    try {
      const payload = values;
      const { data } = await postCoursesLessons({ payload, urlParams: { coursesId } });
      openModal(false);
      reload(true);
      saveContent(array => [...array, data]);
      enqueueSnackbar(t('COMMON.SAVED_SUCCESSFULLY'), { variant: 'success' });
    } catch (e) {
      enqueueSnackbar(t('ERRORS.SOMETHING_WENT_WRONG'), { variant: 'error' });
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={'lg'}
        open={openIs}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        <Formik
          onSubmit={submitWebinars}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          {({ isSubmitting }) => {
            return (
              <>
                <Form className={classes.form} autoComplete="off" noValidate>
                  <AppBar className={classes.appBar}>
                    <Toolbar className={classes.flex_just}>
                      <div className={classes.flex}>
                        <IconButton color="inherit" onClick={handleClose} aria-label="close">
                          <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                          Створити новий урок
                        </Typography>
                      </div>
                      <div>
                        <Button autoFocus color="inherit" type="submit">
                          {t('COMMON.ADD_TO')}
                        </Button>
                      </div>
                    </Toolbar>
                  </AppBar>
                  <DialogContent>
                    <div className={classes.wrapper}>
                      <div className={classes.isForm}>
                        {input.map(field => {
                          return <FieldWithConfig key={field.name} {...field} />;
                        })}
                      </div>
                    </div>
                  </DialogContent>
                </Form>
              </>
            );
          }}
        </Formik>
      </Dialog>
    </>
  );
};

export default CreateCoursesLesson;
